// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Whbf","validationTips":"StatementDescriptor_validationTips__1MQ8t"};